export const billPageSetting = ({ doc }) => {
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.height;
  const marginTop = 15; // Top margin for header
  const lineHeight = 6; // Vertical spacing between lines
  // Column Header Box
  const columnHeaderLeftStart = 15;
  const columnHeaderTopStart = 50;
  const columnHeaderWidth = pageWidth - 30;
  const columnHeaderHeight = 25;
  const columnContentY = 48;
  const footerY = pageHeight - 30; // Y-position for footer
  const endRectParamRatio = 1 / 3;
  const extraSpaceBelowTable = 4;
  return {
    pageWidth,
    pageHeight,
    marginTop,
    lineHeight,
    columnHeaderLeftStart,
    columnHeaderTopStart,
    columnHeaderWidth,
    columnHeaderHeight,
    columnContentY,
    footerY,
    endRectParamRatio,
    extraSpaceBelowTable,
  };
};
